export default __webpack_public_path__ + "static/media/ic_gmx_custom.da7c5dd1.svg";